import React from 'react'
import PropTypes from 'prop-types'
import {withFormsy} from 'formsy-react';
import 'react-image-crop/dist/ReactCrop.css';

import Component from '../Component'
import DragAndDrop from "./DragAndDrop";

class FileUpload extends Component {

    static propTypes = {
        label: PropTypes.any,
        accept: PropTypes.string,
        onError: PropTypes.func,
    };


    static defaultProps = {
        label: 'Image',
        accept: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.slideshow,.pdf,.ppt,.xlsx,.xls,.pptx,.txt,.text,image/*',
    };


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            file: '',
            uploadSrc: null,
            originalSrc: props.getValue() || ''
        };
    }

    onSelectFile = async(files) => {
        if (files && files.length > 0) {
            const file = files[0];
            const lastDot = file.name.lastIndexOf('.');

            const fileName = file.name.substring(0, lastDot);
            const ext = file.name.substring(lastDot + 1);

            console.log('onSelectFile', {current: this.props.getValue(),fileName, ext, path: file.path});

            if (TB.isObject(this.props.getValue())) {
                this.props.setValue(null)
                await TB.wait(50);
            }
            this.props.setValue(file)
        }
    };

    getFileIcon(file) {
        let name = '';
        if (typeof file === 'string') {
            name = file;
        } else if (TB.isObject(file)) {
            name = file?.name || ''
        }
        let lastDot = name.lastIndexOf('.');

        if (lastDot === -1) {
            return 'file-alt';
        }

        let ext = name.substring(lastDot + 1);

        switch (ext) {
            case 'csv':
                return 'file-csv'
            case 'ppt':
            case 'ppxt':
                return 'file-powerpoint'
            case 'xls':
            case 'xlsx':
                return 'file-excel'
            case 'doc':
            case 'docx':
                return 'file-word'
            case 'pdf':
                return 'file-pdf';
            default:
                return 'file-alt';
        }
    }

    getFileName(file) {

        if (this.props.fileNameDisplay) {
            file = this.props.fileNameDisplay(file) || file
        }

        return TB.isString(file) ? file : (file?.name || 'Document')
    }

    formatBytes(bytes, decimals = 2) {
        if (!bytes) return null;
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    render() {

        let {
            getErrorMessage,
            isFormSubmitted,
            showRequired,
            showError,
            label,
            required,
            disabled,
            readOnly
        } = this.props;


        let errorClass = isFormSubmitted() &&
        (showRequired() || showError()) ?
            'is-invalid' :
            null;

        let file = this.props.getValue();

        return (
            <div
                className={`file-upload-container form-group ${errorClass ? 'text-danger' : ''} ${disabled && 'disabled'}`}>
                {label && (
                    <label className="col-form-label" data-required="true">
                        {label}
                        {required && <span className="required-symbol"> *</span>}
                    </label>
                )}

                {file ? (
                    <span className={`btn-file form-component ${errorClass}`}>
                        <div className="file-upload-preview">

                            <p className={this.props.viewable ? 'clickable' : null} onClick={() => {
                                if (this.props.viewable) {
                                    let url = file.path || file
                                    window.open(url, '_blank').focus()
                                }
                            }}>
                                {this.getFileName(file)}
                            </p>

                            <div className="flex-row items-center justify-between">
                               <i className={`far mr-2 fa-${this.getFileIcon(file)}`}/>
                                {this.formatBytes(file?.size || this.props.size) && (
                                    <small className="mr-auto pr-3">
                                        {this.formatBytes(file?.size || this.props.size)}
                                    </small>
                                )}
                                {!disabled && !readOnly && (
                                    <div className="file-edit-action">
                                        <i className="fas fa-folder-open"/>
                                        <input name={this.props.name}
                                               title=" "
                                               type="file"
                                               accept={this.props.accept || FileUpload.defaultProps.accept}
                                               onChange={e => this.onSelectFile(e.target.files)}/>
                                    </div>
                                )}
                                {!disabled && !readOnly && (
                                    <div className="file-remove-action" onClick={() => {
                                        this.props.setValue();
                                    }}>
                                        <i className="btn-file-remove fas fa-trash"/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </span>
                ) : (
                    <DragAndDrop
                        type="file"
                        accept={this.props.accept || FileUpload.defaultProps.accept}
                        handleDrop={this.onSelectFile}
                        instructions={this.props.instructions}
                        disabled={this.props.disabled}
                        name={this.props.name}
                        before={this.props.iconBefore && (
                            <i className={this.props.iconBefore}/>
                        )}
                    />
                )
                }


                <div className="invalid-feedback">
                    <div>{getErrorMessage()}</div>
                </div>

            </div>
        )
    }
}

export default withFormsy(FileUpload);